<template>
  <el-dropdown
    :disabled="menus.length === 0"
    trigger="click"
    @command="(command) => handleCommand(command)"
  >
    <el-button
      icon="el-icon-more"
      size="medium"
      circle
    />
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item
        v-for="menu in menus"
        :key="menu.key"
        :command="menu.key"
      >
        {{ menu.label }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import { mapGetters } from "vuex";
import organizationServices from "@/services/organization";

export default {
  name: "ContractActions",
  props: {
    item: Object,
    approvedData: Array,
    contract: Object,
  },
  computed: {
    ...mapGetters("contract", ["allContractSteps"]),
    approvedItem() {
      return this.approvedData.find((d) => d.document_id === this.item?.id)
    },
    startStep() {
      const org = organizationServices.getCurrentOrg();
      const result = this.allContractSteps.find((s) => {
        return s.contract_id == this.contract?.id && s.order === 0 && s.role_ids.includes(org.management_roles_id)
      })
      return result
    },
    stepActions() {
      if (this.approvedItem) {
        return this.approvedItem.current_step.actions.filter((a) => a.execution?.allowed).map((a) => ({
          ...a,
          started: true,
          step_id: this.approvedItem.current_step.id,
          name: a.translations.vi.name
        }))
      }
      return (this.startStep?.actions || []).map((a) => ({
        ...a,
        step_id: this.startStep?.id,
        name: a.translation.name
      }))
    },
    menus() {
      if (this.stepActions) {
        return this.stepActions.map((a) => ({
          key: a.id,
          label: a.name,
        }))
      }
      return []
    },
  },
  methods: {
    handleCommand(command) {
      const action = this.stepActions.find((s) => s.id == command)
      this.$emit('request', action)
    }
  },
};
</script>

<style lang="scss"></style>
